var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.528,
    height: 15.802,
    viewBox: "0 0 24.528 15.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hide_pw_icon",
    "data-name": "hide pw icon",
    transform: "translate(-27.921 -453.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25534",
    "data-name": "Path 25534",
    d: "M36.209,519.545a4.33,4.33,0,0,1,5.688-5.688l1.722-1.722a12.29,12.29,0,0,0-3.434-.509c-6.773,0-12.264,6.208-12.264,6.208a22.749,22.749,0,0,0,5.633,4.367Z",
    transform: "translate(0 -56.959)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25535",
    "data-name": "Path 25535",
    d: "M335.136,570.2l-2.487,2.487a4.329,4.329,0,0,1-5.866,5.866l-1.769,1.769a12.477,12.477,0,0,0,3.825.629c6.773,0,12.264-6.208,12.264-6.208A22.69,22.69,0,0,0,335.136,570.2Z",
    transform: "translate(-288.654 -113.872)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25536",
    "data-name": "Path 25536",
    d: "M422.157,695.685a3.055,3.055,0,0,0,2.85-4.151l-3.947,3.948A3.047,3.047,0,0,0,422.157,695.685Z",
    transform: "translate(-381.972 -231.757)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25537",
    "data-name": "Path 25537",
    d: "M355.245,622.99a1.1,1.1,0,0,1,.393.072l.314-.314a3.056,3.056,0,0,0-3.678,3.678l1.937-1.937a1.107,1.107,0,0,1,1.035-1.5Z",
    transform: "translate(-315.06 -164.844)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25538",
    "data-name": "Path 25538",
    d: "M178.107,463.471l4.2-4.2.918-.918,2.271-2.271,1.573-1.573a.881.881,0,0,0-1.245-1.245h0l-2.1,2.1-1.8,1.8-.942.942-.434.434-1.56,1.56-2.056,2.056-.942.942-2.412,2.412-1.8,1.8h0a.881.881,0,0,0,1.245,1.245h0l2.289-2.289,1.868-1.868Z",
    transform: "translate(-139.528 0)",
    fill: "#919191"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideIcon2);
export default __webpack_public_path__ + "static/media/hide-icon-2.37dfe0befe5a94d3886ee2790b66a7ec.svg";
export { ForwardRef as ReactComponent };